module.exports = __webpack_public_path__ + "static/media/WS.89588991.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/WS.svg
// module id = 2292
// module chunks = 7